import { MediaService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { mediaKeys } from './mediaKeys';

type TParams = QueryFunctionContext<ReturnType<typeof mediaKeys.analysisStatus>>;

export const createFetchMediaAnalysisStatusQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ mediaId }], signal }: TParams) =>
    call(() => cancelOnSignal(MediaService.getAnalysisStatus({ mediaId }), signal));
